export default __webpack_public_path__ + "/dist/images/2482910.1f5abb9393a06162c7415688ec2bb078.png";